<template>
  <div class="cont">
    <div class="title">
      <div class="title_name"></div>
    </div>

    <div class="clear" style="margin-bottom:37px">
      <el-carousel height="542px">
        <el-carousel-item >
          <el-image
            style=" height: 542px ; cursor : pointer"
            :src="require('@/assets/image/variousproducts/brakecalipers/img1.png')"
            fit="contain"
        ></el-image>
        </el-carousel-item>
        <el-carousel-item >
          <el-image
            style=" height: 542px ; cursor : pointer;"
            :src="require('@/assets/image/variousproducts/brakecalipers/img2.png')"
            fit="contain"
        ></el-image>
        </el-carousel-item>
        <el-carousel-item >
          <el-image
            style=" height: 542px ; cursor : pointer"
            :src="require('@/assets/image/variousproducts/brakecalipers/img3.png')"
            fit="contain"
        ></el-image>
        </el-carousel-item>
      </el-carousel>
      <div style="text-align:center">
        <el-image
            style=" width: 292px "
            :src="require('@/assets/image/variousproducts/brakecalipers/img4.png')"
            fit="contain"
        ></el-image>
      </div>
      <div style="text-align:center;margin-top:36px">
        <el-image
            style=" width: 857px "
            :src="require('@/assets/image/variousproducts/brakecalipers/img5.png')"
            fit="contain"
        ></el-image>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: "ContOne",
  data() {
    return {
      fit: "contain" ,
      background : [

      ] ,
    };
  },
  methods: {
    gotoDetail( id ){
      // console.log( id )
      this.$router.push('/variousproducts/brakedisc/' + id )

    }
  }
};
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  padding: 62px 73px;
  box-sizing: border-box;
  position relative
}

.clear:after {
  display: block;
  clear: both;
  content: '';
}

.title {
  position: absolute;
  width: 268px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/variousproducts/brakecalipers/imgt1.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 39px 46px 39px 48px;
  box-sizing: border-box;
}

.title_name {
  width: 174px;
  height: 30px;
  background: url('~@/assets/image/variousproducts/brakecalipers/imgt2.png');
  background-repeat: no-repeat;
  background-size: contain;
}


.img_cont {
  width: 410px;
  height: 103px;
  float: left;
}
  .img{
    background-repeat: no-repeat;
    background-size: cover;
    float: left;
  }
.img_cont_one
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img1.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img2.png');
    margin-right:6px;
  }
  .img_three{
    width: 53px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img3.png');
    margin-bottom:8px
  }
  .img_four{
    width: 241px;
    height: 70px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img4.png');
  }
.img_cont_two
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img5.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img6.png');
    margin-right:6px;
  }
  .img_three{
    width: 52px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img7.png');
    margin-bottom: 9px
  }
  .img_four{
    width: 241px;
    height: 52px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img8.png');
  }
.img_cont_three
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img9.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img10.png');
    margin-right:6px;
  }
  .img_three{
    width: 60px;
    height: 22px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img11.png');
    margin-bottom: 9px
    background-size contain
  }
  .img_four{
    width: 238px;
    height: 52px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img12.png');
  }
.img_cont_four
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img13.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img14.png');
    margin-right:6px;
  }
  .img_three{
    width: 52px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img15.png');
    margin-bottom: 9px
  }
  .img_four{
    width: 241px;
    height: 52px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img16.png');
  }
.img_cont_five
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img17.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img18.png');
    margin-right:6px;
  }
  .img_three{
    width: 79px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img19.png');
    margin-bottom: 9px
  }
  .img_four{
    width: 241px;
    height: 70px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img20.png');
  }
.img_cont_six
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img21.png');
    margin-right:5px;
  }
  .img_two{
    width: 136px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img22.png');
    background-size: contain;
    background-repeat: no-repeat;
    margin-right:6px;
  }
  .img_three{
    width: 171px;
    height: 23px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img23.png');
    margin-bottom: 8px
  }
  .img_four{
    width: 221px;
    height: 70px;
    background: url('~@/assets/image/variousproducts/brakeDisc/img24.png');
  }

</style>
